import {connect} from "react-redux"
import capitalize from "lodash/capitalize"
import {createSelector} from "reselect"
import State from "../../models/State"
import {setSaleClearanceSearchTerm} from "../../ducks/search"

const selectSaleOrClearance = (state: State) => state.request.saleOrClearance

const makeText = createSelector([selectSaleOrClearance], saleOrClearance => ({
    labelId: `plp-${saleOrClearance}-search-bar-text-input`,
    label: "Search",
}))

export const mapStateToProps = (state: State) => {
    const {saleOrClearance, siteUrl, urlIsSaleOrClearance} = state.request
    const {saleClearanceSearchTerm} = state.search
    return {
        saleOrClearance,
        text: makeText(state),
        saleClearanceSearchTerm,
        placeholder: `Search ${capitalize(saleOrClearance)}`,
        saleClearanceImagePath: `/images/plp/sale/${saleOrClearance}.svg`,
        clearButtonIconPath: "/icons/shared/clear.svg",
        submitButtonIconPath: `/icons/shared/search-input-button.svg`,
        siteUrl,
        urlIsSaleOrClearance,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        onTyping: (chars: string) => {
            dispatch(setSaleClearanceSearchTerm(chars))
        },
        onSubmit: (siteUrl: string, saleOrClearance: string, searchTerm: string) => {
            const url = `${siteUrl}/${saleOrClearance}/search?w=${encodeURIComponent(searchTerm)}`
            window.location.href = url
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
